import {
  ServiceAddOnModel,
  Price,
  SelectedAddOnModel,
  ServiceDiscountByQuantityModel,
  ServicePercentagePriceModel,
  ServicePricingOption,
} from './service.model';

export interface PricingVoucherModel {
  _id: string;
  usedQuota: number;
  amount: PriceModel;
}

export interface PricingDiscountByQuantityModel {
  serviceDiscountByQuantity: ServiceDiscountByQuantityModel;
  appliedToPrice: Price;
  amount: Price;
  amountBase: Price;
}

export interface PricingModel {
  quantity: number;
  consecutiveSlotsQuantity: number;
  totalPrice: Price;
  subtotalServicePrice: Price;
  totalVoucherPrice?: Price;
  totalVoucherBasePrice?: Price;
  discountByQuantity?: PricingDiscountByQuantityModel;
  pricingPromoCode?: PricingPromoCodeModel;
  pricingAddOns?: PricingAddOnsModel;
  pricingPricingOptions?: PricingPricingOptionsModel;
  pricingPercentagePrice?: PricingPercentagePriceModel;
  voucher?: PricingVoucherModel;
}

export interface PricingPromoCodeModel {
  promoCode: PromoCodeModel;
  amount: Price;
}

export interface PricingPercentagePriceModel {
  servicePercentagePrice: ServicePercentagePriceModel;
  data: any;
  amount: Price;
  amountBase: Price;
}

export interface PricingPricingOptionModel {
  servicePricingOption: ServicePricingOption;
  quantity: number;
  amount: PriceModel;
  voucher?: PricingVoucherModel;
}

export interface PricingPricingOptionsModel {
  pricingOptions: PricingPricingOptionModel[];
  total: PriceModel;
}

export interface PricingAddOnModel {
  serviceAddOn: ServiceAddOnModel;
  quantity: number;
  amount: Price;
  baseAmount: Price;
}

export interface PricingAddOnsModel {
  addOns: PricingAddOnModel[];
  total: PriceModel;
}

export interface PriceModel {
  currency: string;
  value: number;
}

export interface PromoCodeModel {
  code: string;
  percentage: number;
}

export interface SelectedPricingOptionModel {
  _id: string;
  quantity: number;
}

export interface CalculatePriceModel {
  promoCode?: string;
  voucher?: string;
  addOns?: SelectedAddOnModel[] | undefined;
  pricingOptions?: SelectedPricingOptionModel[] | undefined;
  service: string;
  quantity: number;
  date?: {
    from?: string;
    to?: string;
  };
  organization?: string;
  apartmentId?: string;
  bookingId?: string;
  /** Id of the cached provider quote (integration services). */
  quoteId?: string;
}
